import api from './api';
import { BaggageRule, CreateBaggageRuleRequest } from '../interfaces/BaggageRule';

export const baggageRuleService = {
  async getAll(): Promise<BaggageRule[]> {
    const response = await api.get('/baggage-rules');
    return response.data;
  },

  async create(data: CreateBaggageRuleRequest): Promise<BaggageRule> {
    const response = await api.post('/baggage-rules', data);
    return response.data;
  },

  async update(id: number, data: Partial<CreateBaggageRuleRequest>): Promise<BaggageRule> {
    const response = await api.patch(`/baggage-rules/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/baggage-rules/${id}`);
  },
};
